import dispatch from ".";
import actions from "../actions";

const UiDispatcher = {
  showToast: (severity, content, duration) =>
    showToast(severity, content, duration),
  hideToaster: () => hideToaster(),
  showBackdrop: () => showBackdrop(),
  hideBackdrop: () => hideBackdrop(),
};

const showToast = (severity, content, duration) => {
  dispatch(actions.SHOW_TOASTER, { severity, content, duration });
};

export const hideToaster = () => {
  dispatch(actions.HIDE_TOASTER);
};

export const showBackdrop = () => {
  dispatch(actions.SHOW_BACKDROP);
};

export const hideBackdrop = () => {
  dispatch(actions.HIDE_BACKDROP);
};

export default UiDispatcher;
